import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react';

type Validator = () => boolean;
type MultiplePurchaseWizardContextType = {
  registerPoValidator: (fn: Validator) => void;
  poValidators: Validator[];
};

const MultiplePurchaseWizardContext = createContext<
  MultiplePurchaseWizardContextType | undefined
>(undefined);

export function MultiplePurchaseWizardProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [poValidators, setPoValidators] = useState<Validator[]>([]);

  const registerPoValidator = useCallback((fn: Validator) => {
    setPoValidators((prev) => [...prev, fn]);
  }, []);

  return (
    <MultiplePurchaseWizardContext.Provider
      value={{
        registerPoValidator,
        poValidators,
      }}
    >
      {children}
    </MultiplePurchaseWizardContext.Provider>
  );
}

export function useMultiplePurchaseWizardContext() {
  const context = useContext(MultiplePurchaseWizardContext);
  if (!context) {
    throw new Error(
      'useMultiplePurchaseWizardContext must be used within a MultiplePurchaseWizardProvider'
    );
  }
  return context;
}
